/**
 * API Client for UI-Commercial
 * Re-exports from @equilateral/ui-shared consolidated API client
 *
 * This file now delegates to the consolidated implementation in ui-shared
 * to eliminate code duplication across the monorepo.
 *
 * Note: The consolidated implementation includes:
 * - Dual API Gateway routing (core vs agents)
 * - Automatic token refresh (placeholder - implement in consuming app)
 * - Tim-Combo standard response formats
 */

import {
  apiClient as sharedApiClient,
  Make_Authorized_API_Call,
  getAuthHeaders,
  isSuccessResponse,
  isErrorResponse,
  API_GATEWAYS,
  API_BASE_URL,
  type TimComboAPISuccessResponse,
  type TimComboAPIErrorResponse,
  type TimComboAPIResponse,
} from '@equilateral/ui-shared';

// Re-export with type aliases for ui-commercial compatibility
export {
  Make_Authorized_API_Call,
  getAuthHeaders,
  isSuccessResponse,
  isErrorResponse,
  API_GATEWAYS,
  API_BASE_URL,
};

export type APIResponse<T = any> = TimComboAPISuccessResponse<T>;
export type APIErrorResponse = TimComboAPIErrorResponse;
export { type TimComboAPIResponse };

// Export apiClient
export const apiClient = sharedApiClient;

// Legacy export name for ui-commercial compatibility
export const apiCall = sharedApiClient.get;
